import Mousetrap from 'mousetrap';
import { generateIBAN, generateFirstName, generateRandomFromList, generateLastName, generateOndernemingsNummer, generatePhoneNumber, generateInfrastructuur, generateEMail, generateGemeenteNaam, generateOpmerking, generateFunctie } from './EasterEggHelper';
import * as pageConstants from '../../constants/EasterEggConstants';
import mergeDeep from "../../util/mergeDeep.js";
import generateGuid from "../../util/guid.js";
import { TochtFrequentieTypes } from "../../constants/DomainConstants";
const isPPD = window.settings.Environment === "PPD";//process.env.NODE_ENV === 'production';

export default class EasterEggHandler {

    constructor(context, page) {
        this.called = 0;
        this.context = context;
        this.page = page;
        this.enabled = window.settings.EasterEggAutoFill;

        this.chooseAutoFill = this.chooseAutoFill.bind(this);

        this.bind = this.bind.bind(this);
        this.unbind = this.unbind.bind(this);
    }

    setPage(page) {
        this.page = page;
    }

    initiateGemeenten(gemeenten) {
        this.gemeenten = gemeenten;
        this.gemeente = generateRandomFromList(this.gemeenten);
    }
    initiatePostcoden(postcoden) {
        this.postcoden = postcoden;
        this.postcode = generateRandomFromList(this.postcoden);
    }

    bind() {
        if (this.enabled)
            Mousetrap.bind([`up right down left enter`], this.chooseAutoFill);

    }
    unbind() {
        if (this.enabled)
            Mousetrap.unbind([`up right down left enter`], this.chooseAutoFill);

    }

    chooseAutoFill() {
        switch (this.page) {
            case pageConstants.NIEUWE_TOCHT_BESTAANDE_ORGANISATOR:
                this.fillNieuweTocht();
                break;
            case pageConstants.WIJZIG_ORGANISATOR:
                this.fillWijzigOrganisator();
                break;
            case pageConstants.WIJZIG_TOCHT:
                this.fillWijzigTocht();
                break;
            case pageConstants.WIJZIG_LUS:
                this.fillWijzigLus();
                break;
            case pageConstants.WIJZIG_TOELATINGEN:
                this.fillWijzigToelatingen();
                break;
            case pageConstants.WIJZIG_PUBLICATIE:
                this.fillWijzigPublicatie();
                break;
        }
    }

    fillNieuweTocht() {
        const test = process.env.NODE_ENV;
        let modelTemp = this.context.state.model;
        modelTemp.gemeenten = isPPD ? ["8facd645-bc88-e811-8158-e0071b66a091", "89acd645-bc88-e811-8158-e0071b66a091"] : ["6725094d-3884-e811-812c-5065f38b2691", "e323094d-3884-e811-812c-5065f38b2691"];
        this.context.setState({ model: modelTemp });
        let model = {
            "id": generateGuid(),
            "aangeslotenBij": this.context.state.model.aangeslotenBij,
            "nietAangeslotenBij": this.context.state.model.nietAangeslotenBij,
            "contactpersoon": {
                "id": generateGuid(),
                "straatEnHuisnummer": "Wegstraat 123 bus 4",
                "land": isPPD ? "0e5db0e6-e457-e611-80de-c4346bacceb8" : "0e5db0e6-e457-e611-80de-c4346bacceb8",
                "postcode": isPPD ? "9df1ca9e-df7b-e611-80d8-c4346bacdfe8" : "4a57ee75-e07b-e611-80d8-c4346bacdfe8",
                "gemeente": isPPD ? "55b4f7f6-eb7b-e611-80d7-c4346bac4ed4" : "77304ef0-eb7b-e611-80d8-c4346bad5274",
                "postcodeNietBelgie": null,
                "gemeenteNietBelgie": null,
                "email": generateEMail(),
                "telefoon": generatePhoneNumber(),
                "persoonId": generateGuid(),
                "naam": generateLastName(),
                "voornaam": generateFirstName(),
                "isStored": false
            },
            "naam": `tocht_${generateFirstName()}_${generateLastName()}`,
            "datum": "2027-08-20T00:00:00",
            "startplaatsInVlaanderen": true,
            "startplaatsLand": test ? "0e5db0e6-e457-e611-80de-c4346bacceb8" : "0e5db0e6-e457-e611-80de-c4346bacceb8",
            "startplaatsPostcode": isPPD ? "55b4f7f6-eb7b-e611-80d7-c4346bac4ed4" : "77304ef0-eb7b-e611-80d8-c4346bad5274",
            "startplaatsGemeenteNietBelgie": null,
            "idToCloneFullTocht": null,
            "isStored": false,
            "organisatorStored": true
        };

        this.context.setState({ model: mergeDeep(this.context.state.model, model) });
    }

    fillWijzigOrganisator() {
        let model = {
            "redenVanStatus": 121450002,
            "organisator": {
                "rechtspersoonlijkheidId": null,
                "andereRechtspersoonlijkheid": null,
                "land": "0e5db0e6-e457-e611-80de-c4346bacceb8",
                "straatEnHuisnummer": "Wegstraat 123 bus 4",
                "postcodeBE": isPPD ? "9df1ca9e-df7b-e611-80d8-c4346bacdfe8" : "4a57ee75-e07b-e611-80d8-c4346bacdfe8",
                "postcode": null,
                "gemeenteBE": isPPD ? "55b4f7f6-eb7b-e611-80d7-c4346bac4ed4" : "77304ef0-eb7b-e611-80d8-c4346bad5274",
                "gemeente": null,
                "aangeslotenBijId": null,
                "nietAangesloten": true,
                "poid": null,
                "redenVanStatus": 121450002
            },
            "contactpersoon": {
                "land": "0e5db0e6-e457-e611-80de-c4346bacceb8",
                "postcodeBE": isPPD ? "9df1ca9e-df7b-e611-80d8-c4346bacdfe8" : "4a57ee75-e07b-e611-80d8-c4346bacdfe8",
                "gemeenteBE": isPPD ? "55b4f7f6-eb7b-e611-80d7-c4346bac4ed4" : "77304ef0-eb7b-e611-80d8-c4346bad5274",
                "postcode": null,
                "gemeente": null,
                "straatEnHuisnummer": "Wegstraat 123 bus 4",
                "email": generateEMail(),
                "telefoon": generatePhoneNumber(),
                "naam": generateLastName(),
                "voornaam": generateFirstName(),
                "isStored": true,
                "isContactpersoonTijdensActiviteit": false,
                "andereContactpersoonTijdensActiviteit": false,
                "redenVanStatus": 121450002
            },
            "contactpersoonTijdensActiviteit": {
                "id": "00000000-0000-0000-0000-000000000000",
                "land": "0e5db0e6-e457-e611-80de-c4346bacceb8",
                "postcodeBE": isPPD ? "9df1ca9e-df7b-e611-80d8-c4346bacdfe8" : "4a57ee75-e07b-e611-80d8-c4346bacdfe8",
                "gemeenteBE": isPPD ? "55b4f7f6-eb7b-e611-80d7-c4346bac4ed4" : "77304ef0-eb7b-e611-80d8-c4346bad5274",
                "postcode": null,
                "gemeente": null,
                "straatEnHuisnummer": "Wegstraat 123 bus 4",
                "email": generateEMail(),
                "telefoon": generatePhoneNumber(),
                "naam": generateLastName(),
                "voornaam": generateFirstName(),
                "isStored": false,
                "isContactpersoonTijdensActiviteit": true,
                "andereContactpersoonTijdensActiviteit": true,
                "redenVanStatus": 121450002
            },
            "verzekerd": { "verzekerd": false }
        };

        const fileComponents = {
            "bewijs_van_verzekering": ["testFile1.pdf", "testFile2.png"]
        };

        this.context.setState(
            {
                model: mergeDeep(this.context.state.model, model),
                fileComponents: fileComponents
            });
    }

    fillWijzigTocht() {
        let model = {
            "frequentie": TochtFrequentieTypes.EENMALIG,
            "verwachtAantalDeelnemers": 5,
            "startplaatsNaam": "startplaats",
            "startplaatsStraat": "startstraat",
            "startplaatsPostcode": isPPD ? "9df1ca9e-df7b-e611-80d8-c4346bacdfe8" : "4a57ee75-e07b-e611-80d8-c4346bacdfe8",
            "deelnamePrijzen": [{ "omschrijving": "Standaard-tarief", "prijs": 10 }],
            "extraOndersteuningDoorANBGewenst": false,
            "reclameInANBGebied": false,
            "machtigingANBDoorgestuurdNaarGemeenten": true
        };
        this.context.setState({ model: mergeDeep(this.context.state.model, model) });
    }

    fillWijzigLus() {
        let model = {
            "afstandKm": 10.0000000000,
            "onverhard": 15.0000000000,
            "vertrekUurVan": "2018-08-09T11:00:00",
            "vertrekUurTot": "2018-08-09T15:00:00",
            "bevoorradingstentenInANBGebied": true,
            "afmetingenBevoorradingstenten": "veif meeter",
            "gpxContent": "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\r\n<gpx version=\"1.0\">\r\n<name>Example gpx</name>\r\n<wpt lat=\"46.57638889\" lon=\"8.89263889\">\r\n<wpt lat=\"46.57638890\" lon=\"8.89263890\">\r\n<ele>2372</ele>\r\n<name>LAGORETICO</name>\r\n</wpt>\r\n<trk><name>Example gpx</name><number>1</number><trkseg>\r\n<trkpt lat=\"46.57608333\" lon=\"8.89241667\"><ele>2376</ele><time>2007-10-14T10:09:57Z</time></trkpt>\r\n<trkpt lat=\"46.57619444\" lon=\"8.89252778\"><ele>2375</ele><time>2007-10-14T10:10:52Z</time></trkpt>\r\n<trkpt lat=\"46.57641667\" lon=\"8.89266667\"><ele>2372</ele><time>2007-10-14T10:12:39Z</time></trkpt>\r\n<trkpt lat=\"46.57650000\" lon=\"8.89280556\"><ele>2373</ele><time>2007-10-14T10:13:12Z</time></trkpt>\r\n<trkpt lat=\"46.57638889\" lon=\"8.89302778\"><ele>2374</ele><time>2007-10-14T10:13:20Z</time></trkpt>\r\n<trkpt lat=\"46.57652778\" lon=\"8.89322222\"><ele>2375</ele><time>2007-10-14T10:13:48Z</time></trkpt>\r\n<trkpt lat=\"46.57661111\" lon=\"8.89344444\"><ele>2376</ele><time>2007-10-14T10:14:08Z</time></trkpt>\r\n<trkpt lat=\"46.57661112\" lon=\"8.89344445\"><ele>2376</ele><time>2007-10-14T10:14:08Z</time></trkpt>\r\n<trkpt lat=\"46.57661113\" lon=\"8.89344446\"><ele>2376</ele><time>2007-10-14T10:14:08Z</time></trkpt>\r\n<trkpt lat=\"46.57661114\" lon=\"8.89344447\"><ele>2376</ele><time>2007-10-14T10:14:08Z</time></trkpt>\r\n</trkseg></trk>\r\n</gpx>",
            "gpxFilename": "test.gpx",
            "groepsstart": true,
            "vertrekuurGroepsstart": "10:00",
            "bepijld": true,
            "beschrijvingPijlen": "heel mooie pijlen"
        };
        this.context.setState({ model: mergeDeep(this.context.state.model, model) });
    }

    fillWijzigPublicatie() {
        let model = {
            "publicatieOpWebsiteSportVlaanderen": true,
            "publicatieOpWebsiteUitInVlaanderen": true,
            "website": "wepsite.com",
            "facebook": "http://www.facebook.com/test",
            "toegankelijkheidVoorKinderen": true,
            "beschrijvingToegankelijkheidKinderen": "geschikt voor kinderen"
        };
        this.context.setState({ model: mergeDeep(this.context.state.model, model) });
    }

    fillWijzigToelatingen() {
        let model = mergeDeep({}, this.context.state.model);

        model.toelatingen.forEach(t => {
            t.opmerkingen = generateOpmerking();
            t.toelatingOK = true;
        });

        this.context.setState({ model: mergeDeep(this.context.state.model, model) });
    }
}